import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { PrefetchLink } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_MARKET_INSTANT_BUY,
  FOOTBALL_ONBOARDING_CHOOSE_COMPETITION,
  FOOTBALL_ONBOARDING_TUTORIAL_PLAY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useGetInteractionContext } from '@sorare/core/src/hooks/useGetInteractionContext';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { useSkipOnboardingMutation } from '@sorare/gameplay/src/hooks/onboarding/useSkipOnboardingMutation';

import { MarketGuidanceLayout } from 'components/onboarding/MarketGuidanceLayout';
import { WinItems } from 'components/onboarding/WinItems';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
  width: 100%;

  @media ${tabletAndAbove} {
    width: auto;
  }
`;

const TutorialWinPage = () => {
  const { isIosApp } = useIsMobileApp();
  const navigate = useNavigate();
  const [skipOnboarding] = useSkipOnboardingMutation();
  const getInteractionContext = useGetInteractionContext();
  const {
    flags: { useSkipTeamRecommendationOnboardingOnIos = false },
  } = useFeatureFlags();

  const onContinue = async () => {
    if (isIosApp && useSkipTeamRecommendationOnboardingOnIos) {
      await skipOnboarding({
        variables: {
          input: {
            sport: Sport.FOOTBALL,
            interactionContext: getInteractionContext(),
          },
          sport: Sport.FOOTBALL,
        },
      });
      navigate(
        `${FOOTBALL_MARKET_INSTANT_BUY}?isOnboardingFlow=true&rarity=limited`
      );
    } else {
      navigate(FOOTBALL_ONBOARDING_CHOOSE_COMPETITION);
    }
  };

  return (
    <MarketGuidanceLayout
      progress={40}
      center
      backUrl={FOOTBALL_ONBOARDING_TUTORIAL_PLAY}
      cta={
        <OnboardingButton size="large" color="secondary" onClick={onContinue}>
          <FormattedMessage {...glossary.continue} />
        </OnboardingButton>
      }
      ctaBackgroundColor="#0c0524"
    >
      <PrefetchLink to={FOOTBALL_ONBOARDING_CHOOSE_COMPETITION} />
      <Root>
        <Vertical gap={1.5} center>
          <FormattedMessage
            id="TutorialWinPage.title"
            defaultMessage="<em>Win</em><label>amazing rewards each Game Week</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <WinItems />
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialWinPage;
